import SettingsModuleEn from '../v2/modules/settings/locale/en';
import SettingsModuleAr from '../v2/modules/settings/locale/ar';
import OrdersTranslations from '../v2/modules/orders/locale/index';
import ReportsTranslations from '../v2/modules/reports/locale/index';
import WhatsAppTranslations from '../v2/modules/whatsapp/locale/index';
import ProductsTranslations from '../v2/modules/products/locale/index';
import InvoicesTranslations from '../v2/modules/invoices/locale/index';
import ContactsTranslations from '../v2/modules/contacts/locale/index';
import IntegrationsTranslations from '../v2/modules/integrations/locale/index';
import ImportsTranslations from '../v2/modules/imports/locale/index';
import KodoratTranslations from '../v2/agents/kodorat/locale/index';
import ZiebartTranslations from '../v2/agents/ziebart/locale/index';
import CoreTranslations from '../v2/modules/core/locale/index';
import HdtcTranslations from '../v2/agents/hdtc/locale/index';
import RealEstateTranslations from '../v2/agents/real-estate/locale/index';
import EAgentTranslations from '../v2/modules/agent-ecommerce/locale/index';
import SocialMentionsTranslations from '../v2/modules/social-mentions/locale/index';
import VerifySyTranslations from '../v2/agents/verify-sy/locale/index';
import LinkerTranslations from '../v2/agents/linker/locale/index';
import SubscriptionTranslations from '../v2/modules/subscription/locale/index';
import SadidleeTranslations from '../v2/agents/sadidlee/locale/index';
import AgentsTranslations from '../v2/agents/shared/locale/index';

export default {
	settings: {
		en: SettingsModuleEn,
		ar: SettingsModuleAr,
	},
	orders: OrdersTranslations,
	reports: ReportsTranslations,
	whatsapp: WhatsAppTranslations,
	products: ProductsTranslations,
	invoices: InvoicesTranslations,
	contacts: ContactsTranslations,
	integrations: IntegrationsTranslations,
	imports: ImportsTranslations,
	education: KodoratTranslations,
	ziebart: ZiebartTranslations,
	core: CoreTranslations,
	hdtc: HdtcTranslations,
	'real-estate': RealEstateTranslations,
	'e-agent': EAgentTranslations,
	'social-mentions': SocialMentionsTranslations,
	'verify-sy': VerifySyTranslations,
	linker: LinkerTranslations,
	subscription: SubscriptionTranslations,
	sadidlee: SadidleeTranslations,
	'agents': AgentsTranslations,
};
